// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".container[data-v-269d94c8] {\n  width: 100%;\n  min-height: 8rem;\n}\n", ""]);
// Exports
module.exports = exports;
